
import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

const CKEditorField = ({ field, form, height=500 }) => {
  const { name, value } = field;

  // Custom image upload handler
  const handleImageUpload = (blobInfo, success, failure) => {
    const token = sessionStorage.getItem("userToken");

    const formData = new FormData();
    formData.append("file", blobInfo.blob());

    fetch("YOUR_IMAGE_UPLOAD_API_URL", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        success(data.image_url); // Return the image URL to TinyMCE
      })
      .catch((error) => {
        failure("Image upload failed: " + error.message);
      });
  };

  const handleEditorChange = (content, editor) => {
    form.setFieldValue(name, content);
  };

  return (
    <Editor
      apiKey="rueh561lhycrgpckg0wk1bqtbzcjvx1g6vrap3phnnsarue9" 
      value={value}
      init={{
        height: height,
        menubar: true,
        menu: {
          happy: { title: 'Happy', items: 'code' }
        },
        plugins: [
          'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
          'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
          'media', 'table', 'emoticons', 'help'
        ],
       
        toolbar:
        'undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code', // Add 'code' here for the "View Source" button
      images_upload_handler: handleImageUpload,
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      setup(editor) {
      },
      }}
      onEditorChange={handleEditorChange}
    />
  );
};

export default CKEditorField;


